import { apiClient, Auth } from '@/shared/api'

import { TContractReceiptInformation } from '../model/schema'

export const getGuestReceiptInformation = async (contractId: number) => {
  const { data } = await apiClient.get<TContractReceiptInformation>({
    endpoint: `/guest/contracts/${contractId}/receipt-info`,
    auth: Auth.REQUIRED,
  })

  return data
}
